/**
 * Init Swiper plugin with default settings.
 */
// Import Swiper modules needed.
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper/modules';

const swiperSetup = () => {
    // Swiper elements
    const swipers = document.querySelectorAll('.row-slideshow');

    class SwiperState {
        constructor(swiper) {
            this.swiper = swiper;
            // Number of slides
            this.children = swiper.querySelectorAll('.swiper-slide').length;
            this.slides = parseInt(this.children, 10);
            // Data from data-* attributes
            this.slidesperview = parseInt(this.swiper.dataset.slidesperview, 10) || 3; // How many slides to display at the time
            this.slidespergroup = parseInt(this.swiper.dataset.slidespergroup, 10) || 1; // How many slides to swipe at the time
            this.spacebetween = !isNaN(parseInt(this.swiper.dataset.spacing, 10)) ? parseInt(this.swiper.dataset.spacing, 10) : 56; // Space between slides
            
            // Default slider settings
            // https://swiperjs.com/
            this.defaultOptions = {
                // Enable Swiper modules
                modules: [Navigation, Pagination, Keyboard, A11y],
                loop: true,
                loopPreventsSliding: false,
                //loopAdditionalSlides: 0,
                //loopAddBlankSlides: false,
                spaceBetween: this.spacebetween,
                keyboard: true,
                navigation: {
                    nextEl: swiper.parentNode.querySelector('.swiper-button-next'),
                    prevEl: swiper.parentNode.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: swiper.parentNode.querySelector('.swiper-pagination')
                },
                slidesPerGroup: 1,
                slidesPerView: 1.3,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: this.slidesperview,
                        slidesPerGroup: this.slidespergroup,
                    },
                }
            };
            this.initSwiper();
        }

        initSwiper() {
            /**
             * init Swiper
             */
            const slideshow = new Swiper(this.swiper, this.defaultOptions);
        }
    }

    if (swipers && typeof Swiper !== 'undefined') {
        /**
         * If Swiper plugin exists, assign Swiper to swiper elements
        */
        swipers.forEach((el) => {
            const swiperEl = new SwiperState(el);
        });
    }
}

window.addEventListener('load', () => {
    swiperSetup();
});